import { Controller } from "@hotwired/stimulus"

// The board's Hide pill (PR team ruling 2026-09-08, placed beside the
// status pill in the date cell per the owner): one PATCH flipping the
// flag, then the board reloads where the person was, because the row
// leaves (or rejoins) the current view. A failed save says so and leaves
// the pill as it was. The click never reaches the row's own navigation.
export default class extends Controller {
  static values = { url: String, hidden: Boolean }

  toggle(event) {
    event.stopPropagation()
    const button = event.currentTarget
    button.disabled = true
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    fetch(this.urlValue, {
      method: "PATCH",
      headers: { "X-CSRF-Token": token, "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ hidden: !this.hiddenValue })
    })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        const y = window.scrollY
        document.addEventListener("turbo:load", () => window.scrollTo(0, y), { once: true })
        window.Turbo.visit(window.location.href, { action: "replace" })
      })
      .catch(() => {
        button.disabled = false
        if (window.showToast) window.showToast("error", this.hiddenValue ? "Could not unhide that release. Nothing was changed." : "Could not hide that release. Nothing was changed.")
      })
  }
}
